module.exports = __webpack_public_path__ + "img/doc.741a387.svg";